/**
 * Returns a capitalized version of the string, for display purposes.
 */
const getDisplayName = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export { getDisplayName };
